module.exports = __webpack_public_path__ + "static/media/FundsImage.2169fc4a.svg";